export function isTestEnv() {
  return import.meta.env.MODE === 'test';
}
